(function () {
  function initCollectionTabs() {
    const sections = document.querySelectorAll('.collection-tabs[data-section-id]');
    sections.forEach(function (section) {
      const sectionId = section.getAttribute('data-section-id');
      const firstActiveIndex = parseInt(section.getAttribute('data-first-active-index') || '0', 10);
      const headings = section.querySelectorAll('.collection-tabs__heading');
      const panels = section.querySelectorAll('.collection-tabs__panel');
      let currentIndex = firstActiveIndex;

      function setActive(index) {
        if (index === currentIndex) return;
        const prevIndex = currentIndex;
        currentIndex = index;

        headings.forEach(function (heading, i) {
          heading.classList.toggle('is-active', i === index);
          heading.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });

        const prevPanel = panels[prevIndex];
        const nextPanel = panels[index];
        if (!prevPanel || !nextPanel) return;

        function afterPanelSwitch() {
          if (window.lenis && typeof window.lenis.resize === 'function') {
            window.lenis.resize();
          }
          if (typeof ScrollTrigger !== 'undefined' && typeof ScrollTrigger.refresh === 'function') {
            ScrollTrigger.refresh();
          }
        }

        if (typeof gsap !== 'undefined') {
          gsap.to(prevPanel, {
            opacity: 0,
            duration: 0.2,
            ease: 'power2.in',
            onComplete: function () {
              prevPanel.classList.remove('is-active');
              nextPanel.classList.add('is-active');
              gsap.set(nextPanel, { opacity: 0 });
              gsap.to(nextPanel, {
                opacity: 1,
                duration: 0.25,
                ease: 'power2.out',
                onComplete: afterPanelSwitch
              });
            }
          });
        } else {
          prevPanel.classList.remove('is-active');
          nextPanel.classList.add('is-active');
          afterPanelSwitch();
        }
      }

      headings.forEach(function (heading, index) {
        heading.addEventListener('click', function () {
          setActive(index);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionTabs);
  } else {
    initCollectionTabs();
  }
})();
